/* unplugin-vue-components disabled */import __unplugin_components_3 from '/Users/Zhuanz/Desktop/source/iafme_web/src/components/International/International_4.vue';
import __unplugin_components_2 from '/Users/Zhuanz/Desktop/source/iafme_web/src/components/International/International_3.vue';
import __unplugin_components_1 from '/Users/Zhuanz/Desktop/source/iafme_web/src/components/International/International_2.vue';
import __unplugin_components_0 from '/Users/Zhuanz/Desktop/source/iafme_web/src/components/International/International_1.vue';
import "core-js/modules/es.function.name.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives } from "vue";
import _imports_0 from '../assets/img/全球.png';
import _imports_1 from '../assets/img/1453-10统一.png';
var _hoisted_1 = {
  "class": "iamfe"
};
var _hoisted_2 = {
  "class": "nav-text"
};
var _hoisted_3 = {
  "class": "iamfe-content"
};
var _hoisted_4 = {
  "class": "nav"
};
var _hoisted_5 = ["onClick"];
export default /*@__PURE__*/_defineComponent({
  __name: 'International',
  setup: function setup(__props) {
    var selectIndex = ref(0);
    var navList = ref([{
      name: '学会简介'
    }, {
      name: '标准委员会'
    }, {
      name: '发展历程'
    }, {
      name: '核心价值观'
    }]);
    var hoverClass = ref(navList.value[0]);
    function clickIamfe(index) {
      console.log(index, 'index');
      selectIndex.value = index;
      hoverClass.value = navList.value[index];
    }
    return function (_ctx, _cache) {
      var _component_International_1 = __unplugin_components_0;
      var _component_International_2 = __unplugin_components_1;
      var _component_International_3 = __unplugin_components_2;
      var _component_International_4 = __unplugin_components_3;
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("p", null, "当前位置：首页>关于IIFA>IIFA全球>" + _toDisplayString(_unref(navList)[_unref(selectIndex)].name), 1)]), _createElementVNode("div", _hoisted_3, [_createElementVNode("ul", _hoisted_4, [_cache[1] || (_cache[1] = _createElementVNode("li", null, [_createElementVNode("img", {
        src: _imports_0,
        style: {
          "width": "55px",
          "height": "55px"
        },
        alt: "",
        srcset: ""
      }), _createElementVNode("p", null, "IIFA全球")], -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(navList), function (item, index) {
        return _openBlock(), _createElementBlock("li", {
          key: index,
          onClick: function onClick($event) {
            return clickIamfe(index);
          },
          "class": _normalizeClass({
            'hover': _unref(hoverClass) == item
          })
        }, [_cache[0] || (_cache[0] = _createElementVNode("img", {
          src: _imports_1,
          alt: "",
          style: {
            "width": "30px",
            "height": "30px",
            "margin-right": "10px"
          },
          srcset: ""
        }, null, -1)), _createElementVNode("p", null, _toDisplayString(item.name), 1)], 10, _hoisted_5);
      }), 128))]), _withDirectives(_createVNode(_component_International_1, null, null, 512), [[_vShow, _unref(selectIndex) === 1]]), _withDirectives(_createVNode(_component_International_2, null, null, 512), [[_vShow, _unref(selectIndex) === 0]]), _withDirectives(_createVNode(_component_International_3, null, null, 512), [[_vShow, _unref(selectIndex) === 2]]), _withDirectives(_createVNode(_component_International_4, null, null, 512), [[_vShow, _unref(selectIndex) === 3]])])]);
    };
  }
});